import type { PlacementWithLogical } from "@chakra-ui/react";
export type { SystemStyleObject } from "@chakra-ui/theme-tools";
export type { PlacementWithLogical } from "@chakra-ui/react";

export { forwardRef } from "@chakra-ui/react";

export const getInsetFromPlacement = (placement: PlacementWithLogical): string => {
    switch (placement) {
        case "bottom-start":
            return "-50% auto auto 50%";
        case "bottom-end":
            return "-50% 50% auto auto";
        case "bottom":
            return "-50% auto auto auto";
        case "top":
            return "auto auto -50% auto";
        case "top-start":
            return "auto auto -50% 50%";
        case "top-end":
            return "auto 50% -50% auto";
        default:
            return "";
    }
};
